// Пиктограммы вариантов «Что делать?» и действий. Смысл никогда не передаётся только цветом (NFR-UX-02).
import type { ReactElement } from "react";

type P = { size?: number; title?: string };

function Svg({ size = 48, title, children }: P & { children: ReactElement | ReactElement[] }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label={title} focusable="false">
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}

const ball = (cx: number, cy: number) => <circle cx={cx} cy={cy} r={5} fill="#fff" stroke="#111" strokeWidth={2} />;
const kid = (cx: number) => <circle cx={cx} cy={18} r={7} fill="var(--team-us)" stroke="#fff" strokeWidth={2} />;

export const choiceIcons: Record<string, (p: P) => ReactElement> = {
  dribbleForward: (p) => (
    <Svg {...p}>
      {kid(12)}
      {ball(16, 30)}
      <path d="M22 30 H40 M34 24 L40 30 L34 36" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" />
    </Svg>
  ),
  dribbleBack: (p) => (
    <Svg {...p}>
      {kid(36)}
      {ball(32, 30)}
      <path d="M26 30 H8 M14 24 L8 30 L14 36" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" />
    </Svg>
  ),
  turn: (p) => (
    <Svg {...p}>
      {kid(10)}
      {ball(14, 30)}
      <path d="M20 30 Q30 30 32 16 M27 19 L32 14 L36 20" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" />
      <circle cx={38} cy={32} r={6} fill="var(--team-them)" />
    </Svg>
  ),
  wait: (p) => (
    <Svg {...p}>
      {kid(24)}
      {ball(28, 32)}
      <path d="M14 42 H34" stroke="currentColor" strokeWidth={3} strokeLinecap="round" />
    </Svg>
  ),
  pass: (p) => (
    <Svg {...p}>
      {kid(10)}
      <circle cx={38} cy={18} r={7} fill="var(--team-us)" stroke="#fff" strokeWidth={2} />
      <path d="M16 22 L32 22" stroke="currentColor" strokeWidth={3} strokeLinecap="round" />
      {ball(24, 22)}
    </Svg>
  ),
  shoot: (p) => (
    <Svg {...p}>
      {kid(10)}
      <rect x={38} y={10} width={6} height={28} fill="none" stroke="currentColor" strokeWidth={3} />
      <path d="M18 26 L34 24" stroke="currentColor" strokeWidth={4} strokeLinecap="round" />
      {ball(30, 24)}
    </Svg>
  ),
  tackle: (p) => (
    <Svg {...p}>
      {kid(14)}
      <circle cx={34} cy={18} r={7} fill="var(--team-them)" />
      {ball(24, 32)}
    </Svg>
  ),
  runBack: (p) => (
    <Svg {...p}>
      {kid(34)}
      <rect x={2} y={14} width={6} height={22} fill="none" stroke="currentColor" strokeWidth={3} />
      <path d="M26 30 H12 M18 24 L12 30 L18 36" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeDasharray="4 3" />
    </Svg>
  ),
};

export function SpeakerIcon({ size = 24 }: P) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor" />
      <path d="M16 8a5 5 0 0 1 0 8M18.5 5.5a8.5 8.5 0 0 1 0 13" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    </svg>
  );
}

export function StarIcon({ size = 48, filled = true }: P & { filled?: boolean }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 2.5l2.9 6 6.6.8-4.9 4.6 1.3 6.5L12 17.2l-5.9 3.2 1.3-6.5L2.5 9.3l6.6-.8z"
        fill={filled ? "var(--hero)" : "none"}
        stroke="#c48a00"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </svg>
  );
}
